import {
  AddDoctorClinicLocationDto,
  ClinicDto,
  CreateClinicDto,
  CreateDoctorClinicDto,
  Organization,
} from 'src/api/generated'
import { ENDPOINTS_TAGS, rootApi } from 'src/v2/store/api/rootApi'

import {
  IClinicResponse,
  IUpdateClinicDto,
  IUpdateClinicMembershipLocationDto,
} from '../clinics.type'

export const clinicApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createClinic: builder.mutation<Organization, CreateClinicDto>({
      query: (data) => {
        return {
          url: `/v1/clinic/`,
          method: 'POST',
          data: {
            ...data,
          },
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.GET_CLINIC],
    }),
    updateClinic: builder.mutation<{}, IUpdateClinicDto>({
      query: (data) => {
        const { id } = data
        return {
          url: `/v1/clinic/${id}`,
          method: 'PATCH',
          data: {
            name: data.name,
            program: data.program,
          },
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.GET_CLINIC],
    }),
    getClinic: builder.query<IClinicResponse, ClinicDto['id']>({
      query: (id) => ({
        url: `/v1/clinic/${id}`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
              {
                type: ENDPOINTS_TAGS.GET_CLINIC,
                id: result.id,
              },
            ]
          : [ENDPOINTS_TAGS.GET_CLINIC],
    }),
    deleteClinic: builder.mutation<{}, ClinicDto['id']>({
      query: (id) => ({
        url: `/v1/clinic/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ENDPOINTS_TAGS.LOCATIONS],
    }),
    updateClinicMembershipLocation: builder.mutation<
      {},
      IUpdateClinicMembershipLocationDto
    >({
      query: (data) => {
        const { membershipLocationId } = data
        return {
          url: `/v1/clinic/update-clinic-membership-location/${membershipLocationId}`,
          method: 'PATCH',
          data: {
            locationId: data.locationId,
            specialty: data.specialty,
          },
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.GET_CLINIC, ENDPOINTS_TAGS.LOCATIONS],
    }),
    addDoctorLocation: builder.mutation<{}, AddDoctorClinicLocationDto>({
      query: (data) => {
        return {
          url: '/v1/clinic/doctor/location',
          method: 'POST',
          data: {
            ...data,
          },
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.GET_CLINIC, ENDPOINTS_TAGS.LOCATIONS],
    }),
    createClinicDoctor: builder.mutation<{}, CreateDoctorClinicDto>({
      query: (data) => {
        return {
          url: '/v1/clinic/doctor',
          method: 'POST',
          data: {
            ...data,
          },
        }
      },
      invalidatesTags: [
        ENDPOINTS_TAGS.GET_CLINIC,
        ENDPOINTS_TAGS.USERS,
        ENDPOINTS_TAGS.LOCATIONS,
      ],
    }),
  }),
})

export const {
  useCreateClinicMutation,
  useUpdateClinicMutation,
  useGetClinicQuery,
  useDeleteClinicMutation,
  useUpdateClinicMembershipLocationMutation,
  useAddDoctorLocationMutation,
  useCreateClinicDoctorMutation,
} = clinicApi
